import { InvitationStatusCode, RelationshipTierCode } from "../models/models";
import { dt } from "../../../shared/themes/redesignTokens";

// ─── Relationship Tier Colors & Labels ───────────────────────

interface TierStyle {
  bg: string;
  text: string;
  border: string;
  label: string;
  labelSk: string;
  icon: string;
}

export const tierStyleMap: Record<RelationshipTierCode, TierStyle> = {
  [RelationshipTierCode.Connected]: {
    bg: "#EBF5FB",
    text: dt.blue,
    border: "#AED6F1",
    label: "Connected",
    labelSk: "Prepojený",
    icon: "handshake",
  },
  [RelationshipTierCode.Preferred]: {
    bg: "#FEF9E7",
    text: "#F59E0B",
    border: "#F9E79F",
    label: "Preferred",
    labelSk: "Preferovaný",
    icon: "star",
  },
  [RelationshipTierCode.Contracted]: {
    bg: "#EAFAF1",
    text: "#27AE60",
    border: "#ABEBC6",
    label: "Contracted",
    labelSk: "Zmluvný",
    icon: "fileText",
  },
};

// ─── Invitation Status Colors & Labels ───────────────────────

interface InvitationStatusStyle {
  bg: string;
  text: string;
  border: string;
}

export const invitationStatusStyleMap: Record<InvitationStatusCode, InvitationStatusStyle> = {
  [InvitationStatusCode.Pending]: {
    bg: "#EBF5FB",
    text: dt.blueHover,
    border: "#AED6F1",
  },
  [InvitationStatusCode.Accepted]: {
    bg: "#EAFAF1",
    text: "#27AE60",
    border: "#ABEBC6",
  },
  [InvitationStatusCode.Declined]: {
    bg: "#F9EBEA",
    text: "#C0392B",
    border: "#F5B7B1",
  },
  [InvitationStatusCode.Expired]: {
    bg: "#F4F6F9",
    text: "#6B7280",
    border: "#D1D5DB",
  },
  [InvitationStatusCode.Cancelled]: {
    bg: "#F4F6F9",
    text: "#9CA3AF",
    border: "#D1D5DB",
  },
  [InvitationStatusCode.Superseded]: {
    bg: "#F4F6F9",
    text: "#9CA3AF",
    border: "#D1D5DB",
  },
};
